import { render, staticRenderFns } from "./IllnessStatsFitter.vue?vue&type=template&id=46f55dcb&scoped=true"
import script from "./IllnessStatsFitter.vue?vue&type=script&lang=js"
export * from "./IllnessStatsFitter.vue?vue&type=script&lang=js"
import style0 from "./IllnessStatsFitter.vue?vue&type=style&index=0&id=46f55dcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f55dcb",
  null
  
)

export default component.exports